import { IResource } from '@/contexts/backoffice/library/models/resource'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { storeResource } from '../../../../../redux/actions/resources'
import { formValidator, resetFormValidator } from '../../../../../redux/actions/validator'
import { IRootState } from '../../../../../redux/types'

function useCreateHandleSubmit(resource: IResource) {
  const dispatch = useDispatch()
  const { isValidForm, msgForm, errorForm } = useSelector((state: IRootState) => state.validator)

  const handleSubmit = () => {
    dispatch(
      formValidator({
        brands: [resource.brand ?? '', 'notempty'],
        resourcetypes: [resource.resourcetypes ?? [], 'notempty'],
        roles: [resource.role ?? '', 'notempty'],
        countries: [resource.countries ?? [], 'notempty'],
        languages: [resource.languages ?? [], 'notempty'],
        visibility: [resource.visibility ?? '', 'notempty'],
        fileNames: [resource.fileNames ?? [], 'notempty']
      })
    )
  }

  useEffect(() => {
    if (isValidForm) {
      dispatch(resetFormValidator())

      const resourceToStore = {
        ...resource,
        brand: resource.brand ? { id: resource.brand.id } : null,
        role: resource.role ? { id: resource.role.id } : null,
        visibility: resource.visibility ? { id: resource.visibility.id } : null,
        line: resource.line ? { id: resource.line.id } : null,
        categoryIds: resource.categories ? resource.categories.map((category: any) => category.id) : null,
        resourcetypeIds: resource.resourcetypes ? resource.resourcetypes.map((resourcetype: any) => resourcetype.id) : null
      }

      dispatch(storeResource(resourceToStore))
    }
  }, [isValidForm])

  return { msgForm, errorForm, handleSubmit }
}

export default useCreateHandleSubmit
